import { render, staticRenderFns } from "./BottomUpModal.vue?vue&type=template&id=0aebe252&scoped=true&"
import script from "./BottomUpModal.vue?vue&type=script&lang=js&"
export * from "./BottomUpModal.vue?vue&type=script&lang=js&"
import style0 from "./BottomUpModal.vue?vue&type=style&index=0&id=0aebe252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aebe252",
  null
  
)

export default component.exports